import type { Space } from '@cocoonspace/sdk-js/types/space'
import mitt from 'mitt'

export type MapEvents = {
	'map.resetToZone': void
	'map.fitBounds': void
	'map.cardOver': Space
	'map.cardOut': void
}

export const mapEmitter = mitt<MapEvents>()
